<template>
  <div class="page">
    <div class="s-filter-box">
      <a-form layout="inline">
        <a-form-item label="Select Table">
          <a-select
            v-model:value="type"
            style="width: 200px"
            placeholder="Please select"
            @change="changeTable"
          >
            <a-select-option
              v-for="item in tables"
              :key="item.seq"
              :value="item.seq"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="openUploadModal(false)">
            <template #icon>
              <CloudUploadOutlined></CloudUploadOutlined>
            </template>
            Mass Upload
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button danger @click="openUploadModal(true)">
            <template #icon>
              <DeleteOutlined />
            </template>
            Mass Delete
          </a-button>
        </a-form-item>

        <a-form-item class="divider-vertical">
          <a-button
            :disabled="currentDatas.length == 0 || hasErrors || isSaveSuccess"
            :loading="saveLoading"
            @click="save"
          >
            <template #icon>
              <SaveOutlined />
            </template>
            Save
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <div class="page-body" ref="pageBodyRef">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :rowClassName="
          (record) => {
            return { error: record.errors.length > 0 }
          }
        "
        :customRow="rowClick"
        :data-source="currentDatas"
        :pagination="false"
        :scroll="{ x: currentTableWidth, y: tableYHeight }"
        size="small"
      >
        <template #bodyCell="{ text, column, record }">
          <template v-if="column.dataIndex === columns[0].dataIndex">
            <a-popover
              title="Tips"
              placement="right"
              v-if="record.errors.length"
              trigger="click"
            >
              <template #content>
                <p v-for="i in record.errors" :key="i">{{ i }}</p>
              </template>
              <span
                style="
                  color: @primary-color;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                <WarningFilled style="color: #f7513c"></WarningFilled>
                {{ text }}
              </span>
            </a-popover>
            <span v-else>{{ text }}</span>
          </template>
        </template>
      </a-table>
    </div>

    <a-modal
      v-model:visible="dialogShow"
      width="500px"
      title="Upload File"
      :confirm-loading="confirmLoading"
      okText="Upload"
      @ok="dialogOk()"
      :okButtonProps="{ disabled: !fileList.length }"
      @cancel="dialogCancel"
    >
      <a-form :labelCol="{ span: 8 }">
        <a-form-item label="Download File">
          <a-button type="link" @click="download" style="padding: 0">
            Download a '.xlsx' File
          </a-button>
        </a-form-item>
        <a-form-item label="Select File">
          <a-upload
            :file-list="fileList"
            :maxCount="1"
            :before-upload="beforeUpload"
            @remove="handleRemove"
          >
            <a-button>
              <upload-outlined></upload-outlined>
              Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { MASTER_CONSTANT } from '@/constant/master_constant'
  import { baseURL } from '@/config'
  import request from '@/utils/request'
  import {
    CloudUploadOutlined,
    DeleteOutlined,
    SaveOutlined,
    UploadOutlined,
    WarningFilled,
  } from '@ant-design/icons-vue'
  import { throttle } from '@/utils'
  import { message } from 'ant-design-vue'

  export default {
    components: {
      CloudUploadOutlined,
      DeleteOutlined,
      SaveOutlined,
      UploadOutlined,
      WarningFilled,
    },

    data() {
      return {
        type: this.$route.query.type * 1 || 0,
        tables: MASTER_CONSTANT.ShipmentMasterTable,
        currentTableWidth: '100%',
        tForm: {},
        dialogShow: false,
        tableYHeight: 300,
        fileList: [],
        isDelete: false,
        hasErrors: false,
        isSaveSuccess: false,
        confirmLoading: false,
        saveLoading: false,
        batchUploadId: '',
        currentDatas: [],
        columns: [],
        dataBody: null,
      }
    },
    watch: {
      type() {
        this.setCurrentColumns()
      },
    },
    computed: {
      currentTable() {
        return MASTER_CONSTANT[this.getTablesName(this.type)]
      },
      ...mapGetters({
        netGroupId: 'user/currentNetGroup',
        currentSystem: 'user/currentSystem',
      }),
    },
    created() {
      const { type } = this.$route.query
      this.type = type * 1 || 0
      this.setCurrentColumns()
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
      this.getCurrentTableWidth()
    },
    methods: {
      rowClick(record) {
        return {
          onClick() {
            console.log(record)
          },
        }
      },
      // 上传前检查
      beforeUpload(file) {
        if (file.type.indexOf('sheet') == -1) {
          message.error('Please upload a .xlsx type file!')
          return false
        }
        if (file.name.indexOf(this.getTablesName(this.type)) === -1) {
          message.error('Wrong excel format.')
          return false
        }
        this.fileList = [...this.fileList, file]
        return false
      },
      dialogCancel() {
        this.confirmLoading = false
        this.fileList = []
      },
      // 上传
      dialogOk() {
        const fd = new FormData()
        fd.append('file', this.fileList[0])
        this.confirmLoading = true
        const name = this.type === 0 ? 'uploadMdRoute' : 'uploadMdJob'

        request({
          url: `/api/shipment/${name}?isDelete=${this.isDelete}`,
          method: 'post',
          data: fd,
          headers: {
            'Content-Type': undefined,
          },
        })
          .then((res) => {
            if (res.errCode === '0000') {
              this.handleDatas(res.body)
              this.dataBody = res.body
              this.dialogShow = false
              this.fileList = []
            } else {
              message.error(res.errMsg)
            }
          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            this.confirmLoading = false
          })
      },
      handleDatas(body) {
        if (body.length) {
          this.currentDatas = body
          this.batchUploadId = body[0]
            ? body[0].batchUploadID || body[0].batchUploadId
            : ''

          const errorsArr = body.filter(
            (item) => item.errors !== null && item.errors.length > 0
          )
          this.hasErrors = errorsArr.length > 0
          this.isSaveSuccess = false
          message.success('Mass upload is successfully completed!')
        } else {
          this.currentDatas = []
          this.batchUploadId = ''
          this.hasErrors = []
        }
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file)
        const newFileList = this.fileList.slice()
        newFileList.splice(index, 1)
        this.fileList = newFileList
      },
      setTableScrollH() {
        const obj = this.$refs.pageBodyRef
        if (!obj) return

        const tableHeader = document.querySelector('.ant-table-header')
        const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44

        this.tableYHeight = obj.clientHeight - tHeadHeight
      },
      getTablesName(type) {
        const f = this.tables.find((item) => item.seq === type)
        return f ? f.name : ''
      },
      getCurrentTableWidth() {
        if (this.currentTable && this.currentTable.length) {
          let cWidth = 0
          this.currentTable.forEach((val) => {
            cWidth += val.width.replace(/%/, '') * 1
          })
          this.currentTableWidth = cWidth + '%'
          return cWidth + '%'
        }
      },
      changeTable() {
        this.getCurrentTableWidth()
        this.currentDatas = []
      },
      setCurrentColumns() {
        if (this.currentTable && this.currentTable.length) {
          this.columns = this.currentTable.map((item, index) => {
            return {
              fixed: index === 0 ? 'left' : '',
              title: item.text,
              dataIndex: item.value,
              width: item.width,
            }
          })
        } else {
          this.columns = []
        }
      },

      openUploadModal(isDelete) {
        this.dialogShow = true
        this.isDelete = isDelete
      },
      download() {
        let name = this.type == 0 ? 'downloadRoute' : 'downloadJob'
        let url = `${baseURL}/api/shipment/${name}?netGroupId=${this.netGroupId}&current-system=${this.currentSystem}`
        window.location.href = url
      },
      save() {
        const name = this.type === 0 ? 'saveMdRoute' : 'saveMdJob'
        request({
          url: `/api/shipment/${name}`,
          method: 'post',
          params: {
            isDelete: this.isDelete,
          },
          data: {
            batchUploadId: this.batchUploadId,
          },
        }).then(() => {
          message.success('Save Success!!!')
          this.isSaveSuccess = true
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 182px);
    overflow: hidden;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
  }
  .divider-vertical {
    position: relative;
    padding-left: 1.111vw;
    &::before {
      content: '';
      display: block;
      width: 0;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-left: 1px solid #ccc;
    }
  }
  :deep(.ant-table) {
    tr.error {
      td {
        border-color: #efdcd9;
        background: #fff0ed;
      }
    }
  }
</style>
